import React from 'react'
import Image from 'gatsby-image'
import './index.scss'

import { useStaticQuery, graphql } from 'gatsby'
import NavBar from '../../components/navbar'

import { rhythm } from '../../utils/typography'
import Timeline from '../../components/timeline'
import Education from '../../components/education'

const About = () => {
  const data = useStaticQuery(graphql`
    query ProfileImage {
      avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      site {
        siteMetadata {
          author
          social {
            github
          }
        }
      }
    }
  `)
  return (
    <div className="about">
      <NavBar />
      <Image
        fluid={data.avatar.childImageSharp.fluid}
        alt="aditya gyawali"
        style={{
          marginRight: rhythm(1 / 2),
          marginBottom: 0,
          height: '150px',
          width: '150px',
          borderRadius: `100%`,
          margin: 'auto'
        }}
        imgStyle={{
          borderRadius: `50%`
        }}
        className="profile__pic"
      />
      <p className="about__info">
        I am a diligent front-end developer focused on generating a career in Finland. I am
        committed and active in software development for different web-based applications and
        websites. My interests are in building scalable websites and apps on different platforms. I
        excel in HTML5/CSS3, JavaScript, especially React/Redux & Node, Express, and MongoDB.
      </p>

      <Timeline />
      <Education />
    </div>
  )
}

export default About
